// --------------------------------------------
// Constants to be used in actions and reducers
// ---------------------------------------------
export const PATIENT_ENROLLMENT_REQUEST = `PATIENT_ENROLLMENT_REQUEST`;
export const PATIENT_ENROLLMENT_SUCCESS = `PATIENT_ENROLLMENT_SUCCESS`;
export const PATIENT_ENROLLMENT_FAILURE = `PATIENT_ENROLLMENT_FAILURE`;

export const PATIENT_SEARCH_REQUEST = `PATIENT_SEARCH_REQUEST`;
export const PATIENT_SEARCH_SUCCESS = `PATIENT_SEARCH_SUCCESS`;
export const PATIENT_SEARCH_FAILURE = `PATIENT_SEARCH_FAILURE`;

export const PATIENT_SEARCH_CLEAR = `PATIENT_SEARCH_CLEAR`;

export const PATIENT_SEARCH_IDENTIFIERS = `PATIENT_SEARCH_IDENTIFIERS`;

export const PATIENT_SEARCH_ALL_DATA_CLEAR = `PATIENT_SEARCH_ALL_DATA_CLEAR`;

export const FETCH_ENROLLED_PATIENT_REQUEST = `FETCH_ENROLLED_PATIENT_REQUEST`;
export const FETCH_ENROLLED_PATIENT_SUCCESS = `FETCH_ENROLLED_PATIENT_SUCCESS`;
export const FETCH_ENROLLED_INSURANCE_SUCCESS = `FETCH_ENROLLED_INSURANCE_SUCCESS`;
export const FETCH_ENROLLED_ADDRESS_SUCCESS = `FETCH_ENROLLED_ADDRESS_SUCCESS`;
export const FETCH_ENROLLED_OVERVIEW_SUCCESS = `FETCH_ENROLLED_OVERVIEW_SUCCESS`;
export const FETCH_ENROLLED_PATIENT_FAILURE = `FETCH_ENROLLED_PATIENT_FAILURE`;

export const NEW_PATIENT_ENROLL_FORM = `NEW_PATIENT_ENROLL_FORM`;

export const UPDATE_DUATION_REQUEST = `UPDATE_DUATION_REQUEST`;
export const UPDATE_DUATION_SUCCESS = `UPDATE_DUATION_SUCCESS`;
export const UPDATE_DUATION_FAILURE = `UPDATE_DUATION_FAILURE`;



// WEBPACK FOOTER //
// ./src/views/state/PatientEnrollment/types.js